<template>
  <ul class="menu-list">
    <v-divider />
    <div style="color: white"></div>

    <router-link
      v-if="['trueid'].includes(selectedBot.type) && isShowMenu('TrueidSystemMaintenance')"
      :to="'/' + $i18n.locale() + '/trueid/system-maintenance'"
      data-position="right"
    >
      <li tabindex="0" class="icon-alert-sign">
        <span>{{ $t('System Maintenance') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="['studio7', 'ticket2', 'ustore'].includes(selectedBot.theme) && isShowMenu('profile')"
      :to="'/' + $i18n.locale() + '/ticket2profile'"
      data-position="right"
    >
      <li tabindex="0" class="icon-ticket">
        <span>{{ $t('Profile') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('ticket3checkin')"
      :to="'/' + $i18n.locale() + '/ticket3/checkin'"
      data-position="right"
    >
      <li tabindex="0" class="icon-ticket">
        <span>{{ $t('Check in/out') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="
        ['studio7', 'ticket2', 'ustore'].includes(selectedBot.theme) &&
        isShowMenu('ticketmanagement')
      "
      :to="'/' + $i18n.locale() + '/ticket2management'"
      data-position="right"
    >
      <li style="position: relative" tabindex="0">
        <em
          style="color: white; position: absolute; left: 18px; top: 18px"
          class="fas fa-ticket-alt"
        />
        <span>{{ $t('Ticket management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('ticket3ticketmanagement')"
      :to="'/' + $i18n.locale() + '/ticket3/ticket-management/ticket'"
      data-position="right"
    >
      <li style="position: relative" tabindex="0">
        <em
          style="color: white; position: absolute; left: 18px; top: 18px"
          class="fas fa-ticket-alt"
        />
        <span>{{ $t('Ticket management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="
        ['studio7', 'ticket2', 'ustore'].includes(selectedBot.theme) &&
        isShowMenu('agentmanagement')
      "
      :to="'/' + $i18n.locale() + '/ticket2agentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('ticket3agentmanagement')"
      :to="'/' + $i18n.locale() + '/ticket3/agent-management/agent'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('survey')"
      :to="'/' + $i18n.locale() + '/survey'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-star" />
        <span>{{ $t('Survey') }}</span>
      </li>
    </router-link>
    <!-- Start TD -->
    <router-link
      v-if="['tdtawandang'].includes(selectedBot.theme) && isShowMenu('ticketmanagement')"
      :to="'/' + $i18n.locale() + '/TDmanagement'"
      data-position="right"
    >
      <li style="position: relative" tabindex="0">
        <em
          style="color: white; position: absolute; left: 18px; top: 18px"
          class="fas fa-ticket-alt"
        />
        <span>{{ $t('Ticket management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="['tdtawandang'].includes(selectedBot.theme) && isShowMenu('agentmanagement')"
      :to="'/' + $i18n.locale() + '/TDagentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>
    <!-- End TD -->
    <!-- Start Toa Paint -->
    <router-link
      v-if="
        [...$store.state.toaPaintPage].includes(selectedBot.pageid) &&
        isShowMenu('ticketmanagement')
      "
      :to="'/' + $i18n.locale() + '/ToaManagement'"
      data-position="right"
    >
      <li style="position: relative" tabindex="0">
        <em
          style="color: white; position: absolute; left: 18px; top: 18px"
          class="fas fa-ticket-alt"
        />
        <span>{{ $t('Ticket management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="
        [...$store.state.toaPaintPage].includes(selectedBot.pageid) && isShowMenu('agentmanagement')
      "
      :to="'/' + $i18n.locale() + '/ToaAgentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>
    <!-- End Toa Paint -->

    <!-- Start CityFresh -->
    <router-link
      v-if="['cityfresh'].includes(selectedBot.theme) && isShowMenu('profile')"
      :to="`/${$i18n.locale()}/CityFreshprofile`"
      data-position="right"
    >
      <li tabindex="0" class="icon-ticket">
        <span>{{ $t('Profile') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="['cityfresh'].includes(selectedBot.theme) && isShowMenu('ticketmanagement')"
      :to="'/' + $i18n.locale() + '/CityFreshManagement'"
      data-position="right"
    >
      <li style="position: relative" tabindex="0">
        <em
          style="color: white; position: absolute; left: 18px; top: 18px"
          class="fas fa-ticket-alt"
        />
        <span>{{ $t('Ticket management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="['cityfresh'].includes(selectedBot.theme) && isShowMenu('agentmanagement')"
      :to="'/' + $i18n.locale() + '/CityFreshAgentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>
    <!-- End CityFresh -->

    <router-link
      v-if="toacrmagentmanagement || ['toaecoupon'].includes(selectedBot.theme)"
      :to="'/' + $i18n.locale() + '/agentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>

    <router-link
      v-if="mitsuWebchatAgentmanagement"
      :to="'/' + $i18n.locale() + '/agentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>

    <router-link
      v-if="isAssetWise"
      :to="'/' + $i18n.locale() + '/agentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>
    <template v-if="['nt'].includes(selectedBot.type)">
      <router-link :to="`/${$i18n.locale()}/check-in-check-out`" data-position="right">
        <li tabindex="0" class="icon-ticket">
          <span>{{ $t('check-in-check-out') }}</span>
        </li>
      </router-link>
    </template>

    <router-link
      v-if="isTigerpolySystemAdmin"
      :to="'/' + $i18n.locale() + '/agentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-users" />
        <span>{{ $t('Agent management') }}</span>
      </li>
    </router-link>

    <!-- <router-link
      v-if="isHotstar"
      :to="'/' + $i18n.locale() + '/hotstar/agent-work-time'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-clock" />
        <span>{{ $t('agent_work_time') }}</span>
      </li>
    </router-link> -->

    <template
      v-if="
        ((!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
          (selectedBot.theme != 'kasikorncareer' || $store.state.userid != 'kbankadmin')) ||
        selectedBot.theme == 'universalutilities'
      "
    >
      <router-link
        v-if="
          (selectedBot.theme !== 'universalutilities' ||
            ['105189164178822', '109677593778236'].includes(selectedBot.pageid)) &&
          isShowMenu('welcome')
        "
        :to="'/' + $i18n.locale() + '/welcome'"
        :data-intro="
          $t(
            'Make a great First Impression moment for your customers by setting Welcome Message here.'
          )
        "
        data-position="right"
      >
        <li tabindex="0" class="icon-greeting">
          <span>{{ $t('Welcome Message') }}</span>
        </li>
      </router-link>
    </template>
    <router-link
      v-if="isShowMenu('conversation') && !isHideFirstAnnouncement"
      :to="'/' + $i18n.locale() + '/first-announcement'"
    >
      <li tabindex="0" class="icon-announcement">
        <span>{{ $t('first_announcement') }}</span>
      </li>
    </router-link>
    <template v-if="['tero'].includes(selectedBot.theme)">
      <router-link :to="'/' + $i18n.locale() + '/questionaire'">
        <li tabindex="0" class="icon-plugin">
          <span>Questionaire</span>
        </li>
      </router-link>
    </template>
    <template
      v-if="!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')"
    >
      <router-link
        v-if="
          isShowMenu('conversation') &&
          (selectedBot.theme !== 'universalutilities' ||
            ['105189164178822', '109677593778236'].includes(selectedBot.pageid))
        "
        :to="'/' + $i18n.locale() + '/conversation'"
        :data-intro="
          $t(
            'This Conversation page is like a heart of CHATBOT, the page will collect all pattern on how Bot replies all messages.'
          )
        "
      >
        <li tabindex="0" class="icon-speech">
          <span>{{ $t('Conversation') }}</span>
        </li>
      </router-link>
    </template>

    <router-link
      v-if="isShowMenu('whatsapp')"
      :to="`/${$i18n.locale()}/whatsapp-template-management`"
    >
      <li style="position: relative" tabindex="0">
        <i
          style="color: white; position: absolute; left: 18px; top: 18px; font-size: 18px"
          class="fab fa-whatsapp"
        ></i>
        <span>{{ $t('whatsapp_template_management') }}</span>
      </li>
    </router-link>
    <template
      v-if="
        ((!selectedBot.pagerole ||
          (selectedBot.pagerole && ['admin', 'livechat'].includes(selectedBot.pagerole))) &&
          (selectedBot.theme != 'kasikorncareer' || $store.state.userid != 'kbankadmin')) ||
        selectedBot.theme == 'universalutilities'
      "
    >
      <router-link
        v-if="
          (['105189164178822', '109677593778236'].includes(selectedBot.pageid) ||
            !['universalutilities', 'scgworkplace', 'toaecoupon'].includes(selectedBot.theme)) &&
          isShowMenu('comment')
        "
        :to="'/' + $i18n.locale() + '/comment'"
        :data-intro="
          $t(
            'To privately chat with the one who comments on your post, this page is how you can set which comment that you want to pull directly to your inbox and how to reply on those comments'
          )
        "
      >
        <li tabindex="0" class="icon-mailbox">
          <span>{{ $t('Comment to Inbox') }}</span>
        </li>
      </router-link>
      <!-- Foodguru Customer Menu -->
      <router-link
        v-if="['foodguru'].includes(selectedBot.theme)"
        :to="'/' + $i18n.locale() + '/FoodguruCustomer'"
      >
        <li tabindex="0" class="icon-plugin">
          <span>{{ $t('Customer') }}</span>
        </li>
      </router-link>

      <router-link
        v-if="
          !['scgworkplace', 'aira', 'assetwise'].includes(selectedBot.theme) &&
          !['tcp-broadcast'].includes(selectedBot.type) &&
          isShowMenu('broadcast')
        "
        :to="'/' + $i18n.locale() + '/broadcast'"
        :data-intro="
          $t(
            'If you want to sent any messages to your customers via Facebook s inbox, you can easily set them here'
          )
        "
      >
        <li tabindex="0" class="icon-broadcast">
          <span>{{ $t('Broadcast') }}</span>
        </li>
      </router-link>

      <router-link v-if="isShowMenu('lon-broadcast')" :to="'/' + $i18n.locale() + '/lon-broadcast'">
        <li tabindex="0" class="icon-megaphone">
          <span>LON {{ $t('Broadcast') }}</span>
        </li>
      </router-link>

      <router-link
        v-if="['tcp-broadcast'].includes(selectedBot.type) && isShowMenu('broadcast')"
        :to="'/' + $i18n.locale() + '/tcp/broadcast'"
        :data-intro="
          $t(
            'If you want to sent any messages to your customers via Facebook s inbox, you can easily set them here'
          )
        "
      >
        <li tabindex="0" class="icon-broadcast">
          <span>{{ $t('Broadcast') }}</span>
        </li>
      </router-link>

      <router-link
        v-if="isSuperrich && !isAgentRole"
        :to="'/' + $i18n.locale() + '/superrich/branches'"
      >
        <li tabindex="0" class="icon-shop">
          <span>{{ $t('branches_management') }}</span>
        </li>
      </router-link>

      <router-link
        v-if="$store.state.rabbitReplyFBPostPage.includes(selectedBot.pageid)"
        :to="'/' + $i18n.locale() + '/rabbitreplyfbpost'"
      >
        <li tabindex="0" class="icon-mailbox">
          <span>{{ $t('Reply Facebook Post') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="
          ['ticket2', 'studio7', 'ustore'].includes(selectedBot.theme) &&
          isShowMenu('productandbranch')
        "
        :to="'/' + $i18n.locale() + '/productandbranch'"
      >
        <li tabindex="0" class="icon-shop">
          <v-icon>ticket-account</v-icon>
          <span>{{ $t('Product & Branch') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="
          [...$store.state.lamyPage].includes(selectedBot.pageid) &&
          $store.state.privilege &&
          $store.state.privilege.role !== 'staff'
        "
        :to="'/' + $i18n.locale() + '/LamyProductAndBranch'"
      >
        <li tabindex="0" class="icon-shop">
          <v-icon>ticket-account</v-icon>
          <span>{{ $t('Product') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="['sahapan'].includes(selectedBot.theme)"
        :to="'/' + $i18n.locale() + '/rewardmanager'"
      >
        <li tabindex="0" class="icon-reward">
          <span>{{ $t('จัดการของรางวัล') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="['runkan'].includes(selectedBot.theme)"
        :to="'/' + $i18n.locale() + '/runnerrunkan'"
      >
        <li tabindex="0" class="icon-plugin">
          <span>{{ $t('Runner Manager') }}</span>
        </li>
      </router-link>
      <template v-if="selectedBot.theme == 'secap' && isShowMenu('template')">
        <router-link :to="'/' + $i18n.locale() + '/secap-service-center-management'">
          <li tabindex="0" class="icon-shop">
            <span>{{ $t('service_center_management') }}</span>
          </li>
        </router-link>
        <router-link :to="'/' + $i18n.locale() + '/secap-maintenance-service-booking'">
          <li tabindex="0" style="position: relative">
            <em
              style="color: white; position: absolute; left: 18px; top: 15px; font-size: 20px"
              class="far fa-address-book"
            />
            <span>{{ $t('maintenance_service_booking') }}</span>
          </li>
        </router-link>
      </template>

      <template v-if="$store.state.livepage.includes(selectedBot.pageid) && isShowMenu('live')">
        <router-link :to="'/' + $i18n.locale() + '/live'">
          <li tabindex="0" class="icon-live">
            <span>{{ $t('Live') }}</span>
            <v-chip small style="width: auto" class="ml-2 new-badge" color="red" disabled>{{
              $t('New')
            }}</v-chip>
          </li>
        </router-link>
      </template>
      <template v-if="selectedBot.theme === 'seagull' && isShowMenu('ticketmanagement')">
        <router-link :to="'/' + $i18n.locale() + '/ticket'">
          <li tabindex="0" class="icon-ticket">
            <span>{{ $t('Ticketing') }}</span>
          </li>
        </router-link>
      </template>
      <template
        v-else-if="
          (['ticket', 'nextcapdev', 'webchat', ...$store.state.ticketThemeList].includes(
            selectedBot.theme
          ) ||
            $store.state.ticketPageid.includes(selectedBot.pageid)) &&
          !['208321456497173', '100825145655476', '103267601317473'].includes(selectedBot.pageid) &&
          !nestleAcommerceGroup &&
          selectedBot.theme !== 'seagull' &&
          !['mordee', 'amaze'].includes(selectedBot.type)
        "
      >
        <router-link :to="'/' + $i18n.locale() + '/ticket'">
          <li tabindex="0" class="icon-ticket">
            <span>{{ $t('Ticketing') }}</span>
          </li>
        </router-link>
      </template>
      <!-- Shop -->
      <router-link
        v-if="
          [...$store.state.lamyPage].includes(selectedBot.pageid) &&
          $store.state.privilege &&
          $store.state.privilege.role !== 'staff'
        "
        :to="'/' + $i18n.locale() + '/LamyManagement'"
      >
        <li tabindex="0" class="icon-shop">
          <span>{{ $t('News/Promotions, Gift') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="[...$store.state.lamyPage].includes(selectedBot.pageid)"
        :to="'/' + $i18n.locale() + '/Membership'"
      >
        <li tabindex="0" style="position: relative">
          <em
            style="color: white; position: absolute; left: 18px; top: 18px"
            class="fas fa-users"
          />
          <span>{{ $t('Membership') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="selectedBot && selectedBot.type === 'hopinnhr' && isShowMenu('template')"
        :to="'/' + $i18n.locale() + '/hopinnhr-human-resource'"
      >
        <li tabindex="0" class="icon-plugin">
          <span>{{ $t('human_resource') }}</span>
        </li>
      </router-link>

      <router-link
        v-if="selectedBot && selectedBot.type === 'yasale-ac' && isShowMenu('template')"
        :to="'/' + $i18n.locale() + '/yasale-ac-admin-menu'"
      >
        <li tabindex="0" style="position: relative">
          <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-cog" />
          <span>{{ $t('admin_menu') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="selectedBot && selectedBot.type === 'nongtungjai'"
        :to="'/' + $i18n.locale() + '/nongtungjai/patient-history'"
      >
        <li tabindex="0" style="position: relative">
          <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-cog" />
          <span>{{ $t('admin_menu') }}</span>
        </li>
      </router-link>
      <router-link v-if="isRoots" :to="`/${$i18n.locale()}/roots/company-management`">
        <li tabindex="0" style="position: relative">
          <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-cog" />
          <span>{{ $t('company_management') }}</span>
        </li>
      </router-link>

      <router-link v-if="isTremendous" :to="`/${$i18n.locale()}/tremendous/customer`">
        <li tabindex="0" style="position: relative">
          <em
            style="color: white; position: absolute; left: 18px; top: 18px"
            class="fas fa-users"
          />
          <span>{{ $t('customer_list') }}</span>
        </li>
      </router-link>
      <router-link v-if="isJuzmatchCrm" :to="`/${$i18n.locale()}/juzmatch/member-dashboard`">
        <li tabindex="0" style="position: relative">
          <em
            style="color: white; position: absolute; left: 18px; top: 18px"
            class="fas fa-users"
          />
          <span>{{ $t('member_dashboard') }}</span>
        </li>
      </router-link>

      <template v-if="isAira">
        <router-link
          v-if="isShowMenu('broadcast')"
          :to="`/${$i18n.locale()}/aira/broadcast`"
          :data-intro="
            $t(
              'If you want to sent any messages to your customers via Facebook s inbox, you can easily set them here'
            )
          "
        >
          <li tabindex="0" class="icon-broadcast">
            <span>{{ $t('Broadcast') }}</span>
          </li>
        </router-link>
        <router-link
          v-if="isShowMenu('seminarManagement')"
          :to="`/${$i18n.locale()}/aira/seminar-management`"
        >
          <li tabindex="0" style="position: relative">
            <em
              style="color: white; position: absolute; left: 18px; top: 18px"
              class="fas fa-users"
            />
            <span>{{ $t('seminar_management') }}</span>
          </li>
        </router-link>
        <router-link
          v-if="isShowMenu('memberManagement')"
          :to="`/${$i18n.locale()}/aira/member-management`"
        >
          <li tabindex="0" style="position: relative">
            <em
              style="color: white; position: absolute; left: 18px; top: 18px"
              class="fas fa-users"
            />
            <span>{{ $t('aira_member_management') }}</span>
          </li>
        </router-link>

        <router-link
          v-if="isShowMenu('agentManagement')"
          :to="`/${$i18n.locale()}/aira/agent-management`"
          data-position="right"
        >
          <li tabindex="0" style="position: relative">
            <em
              style="color: white; position: absolute; left: 18px; top: 18px"
              class="fas fa-users-cog"
            />

            <span>{{ $t('Agent management') }}</span>
          </li>
        </router-link>
      </template>

      <template v-if="$store.state.shoptheme.includes(selectedBot.theme) && isShowMenu('template')">
        <template v-if="!hideShopServicesMenu">
          <router-link
            :to="`/${$i18n.locale()}/template`"
            :data-intro="
              $t(
                'If you sell any product, Shop Service might be another choice to support you. You can edit and update all the selling process here inlcuding add product, payment system, tracking system, etc.'
              )
            "
          >
            <li tabindex="0" class="icon-shop">
              <span>{{ $t('Shop Service') }}</span>
            </li>
          </router-link>
        </template>
      </template>
      <template
        v-else-if="
          ![
            'ceemeagain',
            'scgworkplace',
            'universalutilities',
            'ticket2',
            'studio7',
            'atomicboy',
            'ustore',
            'tdtawandang',
            'mitsuwebchat',
            'secap',
            'aira',
            'assetwise',
            'kasikorncareer'
          ].includes(selectedBot.theme) && isShowMenu('template')
        "
      >
        <router-link :to="'/' + $i18n.locale() + '/template'">
          <li tabindex="0" class="icon-plugin">
            <span>{{ pluginMenu }}</span>
          </li>
        </router-link>
      </template>

      <template
        v-if="
          ['toacrm'].includes(selectedBot.theme) &&
          $store.state.privilege &&
          $store.state.privilege.role === 'superadmin'
        "
      >
        <router-link :to="'/' + $i18n.locale() + '/toacrm/terms-and-conditions'">
          <li tabindex="0" class="icon-plugin">
            <span>Terms & Conditions</span>
          </li>
        </router-link>
      </template>
      <template v-if="['toaecoupon'].includes(selectedBot.theme)">
        <router-link :to="'/' + $i18n.locale() + '/toamember'">
          <li tabindex="0" class="icon-plugin">
            <span>ข้อมูลสมาชิก</span>
          </li>
        </router-link>
        <router-link :to="'/' + $i18n.locale() + '/toacampaign'">
          <li tabindex="0" class="icon-megaphone">
            <span>จัดการแคมเปญ</span>
          </li>
        </router-link>
      </template>
      <router-link
        v-if="selectedBot.theme === 'seagull' && isShowMenu('livechat')"
        :to="'/' + $i18n.locale() + '/allinonechat'"
      >
        <li tabindex="0" class="icon-speech">
          <span>{{ $t('All in one chat') }}</span>
        </li>
      </router-link>
      <router-link
        v-if="
          (isShowMenu('livechat') &&
            selectedBot.pagetype == 'enterprise' &&
            ($store.state.livechatPageList.includes(selectedBot.theme) ||
              $store.state.livechatPageIdList.includes(selectedBot.pageid))) ||
          (selectedBot.isUnlockLivechat && selectedBot.theme !== 'seagull') ||
          (selectedBot.theme == 'ecommercebasic' && selectedBot.pageid == '270028443161479') ||
          (selectedBot.theme == 'secap' && $store.state.privilege.role !== 'admin') ||
          (selectedBot.unlock_livechat &&
            selectedBot.theme !== 'seagull' &&
            !isJorakay &&
            !isOceanPsyjai)
        "
        :to="'/' + $i18n.locale() + '/allinonechat'"
      >
        <li tabindex="0" class="icon-speech">
          <span>{{ $t('All in one chat') }}</span>
        </li>
      </router-link>

      <router-link
        v-if="
          isShowMenu('livechat') &&
          selectedBot.features &&
          selectedBot.features.includes('all-in-one-chat-new')
        "
        :to="'/' + $i18n.locale() + '/allinonechat-new'"
      >
        <li tabindex="0" class="icon-speech">
          <span>{{ $t('All in one chat') }} (alpha version)</span>
        </li>
      </router-link>
    </template>
    <template v-if="isAssetWise">
      <router-link
        :to="`/${$i18n.locale()}/assetwise/broadcast`"
        :data-intro="
          $t(
            'If you want to sent any messages to your customers via Facebook s inbox, you can easily set them here'
          )
        "
      >
        <li tabindex="0" class="icon-broadcast">
          <span>{{ $t('Broadcast') }}</span>
        </li>
      </router-link>
      <router-link :to="'/' + $i18n.locale() + '/assetwise/executive-management'">
        <li tabindex="0" class="icon-executive-management">
          <span>{{ $t('asset_wise.sidebar.executive_management') }}</span>
        </li>
      </router-link>
      <router-link :to="'/' + $i18n.locale() + '/assetwise/management'">
        <li tabindex="0" class="icon-management">
          <span>{{ $t('asset_wise.sidebar.management') }}</span>
        </li>
      </router-link>
    </template>
    <template v-if="selectedBot.type === 'tigerpoly'">
      <router-link :to="`/${$i18n.locale()}/tigerpoly/members`">
        <li tabindex="0" class="icon-member">
          <span>{{ $t('member') }}</span>
        </li>
      </router-link>
      <router-link :to="`/${$i18n.locale()}/tigerpoly/reporting`">
        <li tabindex="0" class="icon-reporting">
          <span>{{ $t('reporting_management') }}</span>
        </li>
      </router-link>
    </template>
    <router-link
      v-if="isShowMenu('dashboard')"
      :to="'/' + $i18n.locale() + '/dashboard'"
      :data-intro="
        $t('It is the place where you can see both analytics data; conversation and customer')
      "
    >
      <li tabindex="0" class="icon-analytics">
        <span>{{ $t('analytics') }}</span>
      </li>
    </router-link>
    <router-link v-if="isShowMenu('gpt')" :to="'/' + $i18n.locale() + '/chat-gpt-analytics'">
      <li tabindex="0" class="icon-analytics">
        <span>Chat GPT {{ $t('analytics') }}</span>
      </li>
    </router-link>
    <template v-if="['1637674519806774', '105017609020919'].includes(selectedBot.pageid)">
      <router-link :to="'/' + $i18n.locale() + '/aira-aiful/members'">
        <li tabindex="0" class="icon-member">
          <span>{{ $t('member') }}</span>
        </li>
      </router-link>
    </template>
    <router-link
      v-if="[...$store.state.lamyPage].includes(selectedBot.pageid)"
      :to="'/' + $i18n.locale() + '/PurchaseBehavior'"
    >
      <li tabindex="0" class="icon-analytics">
        <span>{{ $t('Purchase Behavior') }}</span>
      </li>
    </router-link>
    <router-link v-if="isShowMenu('eventTracking')" :to="'/' + $i18n.locale() + '/event-tracking'">
      <li tabindex="0" class="icon-track">
        <span>Event Tracking</span>
      </li>
    </router-link>

    <template
      v-if="!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')"
    >
      <router-link
        v-if="isShowMenu('training')"
        :to="'/' + $i18n.locale() + '/training'"
        :data-intro="$t('This page is for training Bot to be smarter, and reduce default words !')"
      >
        <li tabindex="0" class="icon-gym">
          <span>{{ $t('Training') }}</span>
        </li>
      </router-link>
    </template>
    <template v-if="[...$store.state.bbqPage].includes(selectedBot.pageid)">
      <router-link
        :to="'/' + $i18n.locale() + '/bbq/unanswered-message-info'"
        :data-intro="$t('Unanswered Message Info')"
      >
        <li tabindex="0" class="icon-speech">
          <span>{{ $t('unanswered_msg_info') }}</span>
        </li>
      </router-link>
    </template>

    <template v-if="selectedBot && ['gpf', 'mtc', 'nt'].includes(selectedBot.type)">
      <router-link
        :to="'/' + $i18n.locale() + '/export'"
        :data-intro="$t('This page is for export data')"
      >
        <li tabindex="0" style="position: relative">
          <em
            style="color: white; position: absolute; left: 18px; top: 18px"
            class="fas fa-file-export mr-1"
          />
          <span>{{ $t('export') }}</span>
        </li>
      </router-link>
    </template>

    <template v-if="isShowMenu('adsSimulator')">
      <router-link
        :to="`/${$i18n.locale()}/ads-simulator`"
        :data-intro="$t('messenger_ads_simulator')"
      >
        <li tabindex="0" class="icon-speech">
          <span>{{ $t('messenger_ads_simulator') }}</span>
        </li>
      </router-link>
    </template>

    <template v-if="isShowMenu('beacon')">
      <router-link :to="'/' + $i18n.locale() + '/beacon'">
        <li tabindex="0" style="position: relative">
          <em style="color: white; position: absolute; left: 18px; top: 18px" class="fas fa-rss" />
          <span>{{ $t('beacon') }}</span>
        </li>
      </router-link>
    </template>

    <template v-if="isShowMenu('audience')">
      <router-link :to="'/' + $i18n.locale() + '/audience'">
        <li tabindex="0" class="icon-audience">
          <span>{{ $t('step_message.title') }}</span>
        </li>
      </router-link>
    </template>

    <template v-if="isShowMenu('lineRichMenu')">
      <router-link :to="'/' + $i18n.locale() + '/line-rich-menu'">
        <li tabindex="0" class="icon-grid">
          <span>LINE Rich Menu</span>
        </li>
      </router-link>
    </template>

    <template v-if="isShowMenu('survey-iframe')">
      <router-link :to="'/' + $i18n.locale() + '/survey-iframe'">
        <li tabindex="0" class="icon-survey">
          <span>{{ $t('survey') }}</span>
        </li>
      </router-link>
    </template>

    <v-divider />

    <template
      v-if="
        (!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
        (selectedBot.theme != 'kasikorncareer' || $store.state.userid != 'kbankadmin')
      "
    >
      <router-link
        v-if="isShowMenu('setting')"
        :to="'/' + $i18n.locale() + '/setting'"
        :data-intro="
          $t(
            'On Setting Page, you can  turn On / Off Bot, remove Bot, and check your Subscription Day Remaining. But please dont remove me :('
          )
        "
      >
        <li tabindex="0" class="icon-setting">
          <span>{{ $t('Setting') }}</span>
        </li>
      </router-link>

      <template v-if="['tdtawandang'].includes(selectedBot.theme)">
        <router-link :to="'/' + $i18n.locale() + '/tdnotificationsetting'">
          <li tabindex="0" class="icon-plugin">
            <span>All-in-one chat setting</span>
          </li>
        </router-link>
      </template>
    </template>

    <!-- <template
                  v-if="
                    !selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "
                >
                  <router-link
                    v-if="['universalutilities','scgworkplace', 'scgallrent'].includes(selectedBot.theme) == false"
                    :to="'/' + $i18n.locale() + '/redeemcode'"
                    :data-intro="
                      $t(
                        'On Setting Page, you can  turn On / Off Bot, remove Bot, and check your Subscription Day Remaining. But please dont remove me :('
                      )
                    "
                  >
                    <li tabindex="0" class="icon-ticket">
                      <span>{{ $t('Redeem Code') }}</span>
                    </li>
                  </router-link>
                </template>-->
    <!-- <a
                  href="https://blog.zwiz.ai/getstarted-zwizai/"
                  target="_blank"
                  :data-intro="$t('Have a question? got an answer at tutorial.')"
                  v-if="
                    (selectedBot.theme != 'kasikorncareer' ||
                      $store.state.userid != 'kbankadmin') &&
                      selectedBot.theme != 'universalutilities'
                  "
                >
                  <li tabindex="0" class="icon-help">
                    <span>{{ $t('help') }}</span>
                  </li>
                </a>-->
    <li
      tabindex="0"
      class="icon-sign-out"
      :data-intro="$t('Click here, if your setting is finished or if you want to sigh out.')"
      @click="logout"
    >
      <span>{{ $t('Sign Out') }}</span>
    </li>
    <v-divider />
    <template v-if="isShowMenu('advancesetting')">
      <router-link :to="`/${$i18n.locale()}/advanced-setting/page-config`">
        <li tabindex="0" class="icon-setting">
          <span>{{ $t('Advance Setting') }}</span>
        </li>
      </router-link>
    </template>
    <template
      v-if="
        ((isShowMenu('upgrade') && !selectedBot.pagerole) ||
          (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
        selectedBot.pagetype != 'enterprise' &&
        (selectedBot.theme != 'kasikorncareer' || $store.state.userid != 'kbankadmin')
      "
    >
      <router-link
        :to="'/' + $i18n.locale() + '/upgrade'"
        :data-intro="$t('To see the differences between Basic and Premium Package, click here')"
      >
        <li tabindex="0" class="icon-premium">
          <span>
            {{ $t('Upgrade to Premium Plan') }}
            <v-chip small style="width: auto" class="ml-2 new-badge" color="red" disabled>{{
              $t('New')
            }}</v-chip>
          </span>
        </li>
      </router-link>
    </template>
  </ul>
</template>

<script>
import MainMenuList from './MainMenuList.js'
export default {
  mixins: [MainMenuList]
}
</script>

<style lang="scss">
.menu.default {
  background-color: #ff846d !important;
}
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: var(--secondary-color);
      }
    }

    a {
      text-decoration: none;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-member {
        background-image: url('/static/img/assets/sidebar/member.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }
      &.icon-reward {
        background-image: url('/static/img/assets/sidebar/reward.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }
      &.icon-live {
        background-image: url('/static/img/assets/sidebar/live.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/technical-support.svg');
      }

      &.icon-alert-sign {
        background-image: url('/static/img/assets/sidebar/alert-sign.svg');
        fill: white;
      }

      &.icon-executive-management {
        background-image: url('/static/img/assets/sidebar/user-check-solid.svg');
      }

      &.icon-management {
        background-image: url('/static/img/assets/sidebar/map-location-dot-solid.svg');
      }

      &.icon-reporting {
        background-image: url('/static/img/assets/sidebar/reporting.svg');
      }

      &.icon-announcement {
        background-image: url('/static/img/assets/sidebar/announcement.svg');
      }

      &.icon-broadcast {
        background-image: url('/static/img/assets/sidebar/broadcast.svg');
      }

      &.icon-audience {
        background-image: url('/static/img/assets/sidebar/stepmessage.svg');
      }

      &.icon-grid {
        background-image: url('/static/img/assets/sidebar/grid.svg');
      }

      &.icon-survey {
        background-image: url('/static/img/assets/sidebar/survey.svg');
      }

      &.icon-track {
        background-image: url('/static/img/assets/sidebar/track.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MenuList/MainMenuList.vue